<style scoped lang="less">
/deep/ .tablestitle {
	color: #333;

	.cell {
		font-weight: 600 !important;
	}

	// font-size: 1rem;
}

.choiostitle {
	display: flex;
	padding: 0.8rem 0.4rem;
	align-items: center;
	justify-content: space-between;
	background-color: #fff;
	margin-bottom: 1rem;
	border-left: 4px solid #0acf97;

	.choiosvspde {
		/deep/ .el-button-group {
			width: 9rem;

			button:first-child {
				width: 7rem;
				height: 2rem;
				padding: 0 3px;
			}

			button:last-child {
				width: 1.6rem;
				height: 2rem;
				position: relative;
				padding: 0;
				top: 0px;
				left: 0px;
			}
		}
	}

	.choiostitleleft {
		padding: 0.5rem;
		font-size: 0.8rem;
		border-radius: 50%;
		color: #fff;
		background-color: #0acf97;
		border: 1px solid;
		text-align: left;
		margin-left: 0.6rem;
		box-sizing: border-box;

		span {
			font-weight: 900;
			font-size: 1.2rem;
		}
	}

	.choiosvdate {
		width: 10rem;
		margin-right: 2%;

		/deep/ .el-input {
			width: 100%;
		}
	}

	.choiosipt {
		// width: 9rem;
		margin-right: 2%;

		/deep/ .el-input {
			width: 100%;
		}
	}

	.choiostitleright {
		display: flex;
		align-items: center;
		justify-content: flex-end;

		div {
			margin: 0 0.2rem;
		}

		.choiosipt {
			/deep/ .el-input--prefix .el-input__inner {
				height: 2rem;
				padding: 1rem 2rem;
			}

			/deep/ .el-input__prefix {
				top: -3px;
			}

			/deep/ .el-input__suffix {
				top: -3px;
			}
		}
	}
}

.orderstable {
	// margin-top: 1rem;
	padding: 1rem;
	width: 100%;
	background-color: #fff;
	border-top: 4px solid #ab26aa;
	border-radius: 2px;

	.oderlookds {
		background-color: #f41127;
	}

	.oderlookd {
		padding: 0.1rem;
		width: 4rem;
		background: rgb(78, 192, 204);
		color: rgb(255, 255, 255);
		margin: 0 auto;
		border-radius: 5px;
	}

	.tabslis {
		/deep/ & ::-webkit-scrollbar {
			width: 5px;
			height: 8px;
			background: linear-gradient(to right, #2e61bf, #60c363);
		}

		& ::-webkit-scrollbar {
			width: 10px;
			height: 5px;
			// background: red;
		}

		& ::-webkit-scrollbar-track {
			-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
			border-radius: 0;
			background: rgba(0, 0, 0, 0.1);
		}

		/deep/ .el-table {
			th,
			td {
				text-align: center;
			}

			td {
				button {
					color: #fff;
					border-radius: 5px;
				}

				.looking {
					background: #0d6efd;
					margin-left: 10px;

					span {
						font-size: 0.6rem;
						font-weight: 800;
					}
				}

				.looking:hover {
					background: #0b67e6;
				}

				.giveempower {
					background: #ff8300;

					span {
						font-size: 0.6rem;
					}
				}

				.giveempower:hover {
					background: #e17000;
				}

				.edit {
					background: #17a001;

					span {
						font-size: 0.6rem;
					}
				}

				.edit:hover {
					background: #1fcf00;
				}

				.delete {
					background: #ec0f25;

					span {
						font-size: 0.6rem;
					}
				}

				.delete:hover {
					background: #ff1128;
				}
			}
		}
	}

	.tabsnum {
		height: 4rem;
		display: flex;
		align-items: center;
		justify-content: space-between;

		p {
			color: #333;
		}

		.elpagian {
			margin-right: 1rem;
		}

		/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
			background: linear-gradient(to right, #018761, #39b170);
			// color: #FFF;
		}
	}

	.schooltitle {
		font-size: 1.2rem;
		color: #ab26aa;
		display: flex;
		align-items: center;
		border-bottom: 1px solid #ccc;
		padding-bottom: 1rem;
		position: relative;

		button {
			padding: 0.4rem;
			background: #fe8930;
			font-size: 0.6rem;
			border-radius: 3px;
			padding: 0.6rem 1.2rem;
			position: absolute;
			right: 1%;
			color: #fff;

			span {
				color: #fff;
				margin-right: 0.2rem;
				font-weight: 900;
			}
		}

		span.el-icon-s-management {
			display: block;
			padding: 0.4rem;
			border-radius: 50%;
			font-size: 1rem;
			margin-right: 0.4rem;
			box-sizing: border-box;
			background: #ab26aa;
			color: #fff;
		}
	}
}

.paginations {
	height: 3rem;
	line-height: 3rem;

	input {
		width: 3rem;
		height: 1.8rem;
		padding: 0 0 0 0.8rem;
		border: 1px solid #ccc;
	}
}
</style>
<template>
	<div>
		<titles titlename="实训考勤认证" titlecontent="这里可以看到考勤认证的一些信息" :mbx="paths"></titles>
		<div class="choios">
			<div class="choiostitle">
				<button class="choiostitleleft "><img src="../../images/file-text.svg" alt="" style="width: 2rem;height: 2rem;padding: 0.1rem;" /></button>
				<div class="choiostitleright col-xs-8 col-sm-8 col-md-8 col-lg-8">
					<div class="choiosipt col-xs-4 col-sm-4 col-md-4 col-lg-4">
						<el-input @change="searchs()" placeholder="请输入用户名" prefix-icon="el-icon-search" v-model="ui_userName"></el-input>
					</div>
					<div>
						<el-dropdown @command="getuserlistas">
							<el-button style="padding: 9px 15px;">
								{{ school_name }}
								<i class="el-icon-arrow-down el-icon--right"></i>
							</el-button>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item :command="allschool">全部</el-dropdown-item>
								<el-dropdown-item :command="item" v-for="(item, index) in school_list" :key="index">{{ item.si_name_cn }}</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</div>

					<div>
						<el-dropdown @command="getusercla">
							<el-button style="padding: 9px 15px;">
								{{ classlistnems }}
								<i class="el-icon-arrow-down el-icon--right"></i>
							</el-button>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item :command="allclass">全部</el-dropdown-item>
								<el-dropdown-item :command="item" v-for="(item, index) in classlists" :key="index">{{ item.cla_name }}</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</div>
				</div>
			</div>

			<div class="orderstable">
				<p class="schooltitle">
					<!-- <span class="el-icon-s-management"></span> -->
					<span>实训考勤认证</span>
				</p>
				<div class="paginations">
					每页显示
					<input @change="pagesizechanes()" type="number" oninput="if(value>30)value=30;if(value<2)value=1" v-model="pagesize" />
					行
				</div>
				<div class="tabslis">
					<template>
						<el-table ref="multipleTable" header-row-class-name="tablestitle" tooltip-effect="dark" :data="tableData" border style="width: 100%">
							<el-table-column fixed :resizable="false" type="selection" width="55"></el-table-column>
							<el-table-column prop="ul_operateType" :resizable="false" label="登录类型" width="100"></el-table-column>
							<el-table-column prop="ul_visitSystem" :resizable="false" label="登录来源" width="120"></el-table-column>
							<el-table-column prop="ul_recordTime" :resizable="false" label="登录时间" width="200">
								<template slot-scope="scope">
									<span>{{ scope.row.ul_recordTime ? scope.row.ul_recordTime.replace('T', ' ') : '' }}</span>
								</template>
							</el-table-column>
							<el-table-column prop="ui_realName" :resizable="false" label="姓名" width="150"></el-table-column>
							<el-table-column prop="si_name_cn" :resizable="false" label="所属学院" width="350"></el-table-column>
							<el-table-column prop="cla_name" :resizable="false" label="所属班级"></el-table-column>
						</el-table>
					</template>
				</div>

				<div class="tabsnum">
					<p>
						显示
						<span>1</span>
						到
						<span>{{ pagesize }}</span>
						,共
						<span>{{ pagggenums }}</span>
						条记录
					</p>
					<div class="elpagian">
						<el-pagination @current-change="handleCurrentChange" background layout="prev, pager, next" :page-size="pagesizes" :total="pagggenums"></el-pagination>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import titles from '@/components/title/title.vue';
import {
	// GetrzPageLogList,
	GetPageUserlogList,
	DeleteLog,
	GetyyGetClassList
} from '@/request/api/dataorder/dataprder.js';
import { GetbjGetSchoolList } from '@/request/api/mange/mange.js';
import AppOptions from '@/config/AppOptions.vue';

var that;
export default {
	data() {
		return {
			allschool: {
				si_guid: '',
				si_name_cn: '全部'
			},
			allclass: {
				cla_guid: '',
				allschool: '全部'
			},
			pageindex: 1,
			pagesize: 10,
			pagggenums: 0,
			tabsnun: 10,
			si_guid: '',
			ui_userName: '',
			school_list: [],
			school_name: '全部',
			// 搜索
			search: '',
			// 标题
			paths: [
				{
					path: '/basicmanage/attendanceCertification',
					name: '实训考勤认证'
				}
			],
			tableData: [
				{
					classname: '系统错误',
					classtype: '登录模块',
					classtypes: '错误日志文字说明...',
					classmoude: '单机模式',
					angintime: '2022-07-20 13:30:00'
				},
				{
					classname: '系统错误',
					classtype: '登录模块',
					classtypes: '错误日志文字说明...',
					classmoude: '单机模式',
					angintime: '2022-07-20 13:30:00'
				},
				{
					classname: '系统错误',
					classtype: '登录模块',
					classtypes: '错误日志文字说明...',
					classmoude: '单机模式',
					angintime: '2022-07-20 13:30:00'
				}
			],
			// 班级列表
			classlists: [],
			classlistnems: '全部',
			classlistids: ''
		};
	},
	components: {
		titles
	},

	beforeMount() {
		GetbjGetSchoolList().then(res => {
			this.school_list = res.data.data;
			// console.log('siguid========>', localStorage.getItem('siguid'));
			if (localStorage.getItem('siguid')) {
				this.si_guid = localStorage.getItem('siguid');
				this.school_list.forEach(item => {
					if (this.si_guid == item.si_guid) {
						this.school_name = item.si_name_cn;
					}
				});
			} else {
				this.si_guid = res.data.data[0].si_guid;
			}
			this.classlistsa(this.si_guid);

			// console.log('拿一下学校ID=======>', this.si_guid);
		});
	},
	created() {
		AppOptions.appEmpty = false;
	},
	mounted() {
		// that = this;
	},
	computed: {
		pagesizes() {
			return Number(this.pagesize);
		}
	},
	methods: {
		classlistsa(claid) {
			GetyyGetClassList(claid).then(res => {
				if (res.data.code != 0) {
					// console.log("班级",res)
					// console.log('班级id>>>>>>>>', JSON.parse(localStorage.getItem('usercenter')).cla_guid);
					this.classlists = res.data.data;
					if (JSON.parse(localStorage.getItem('usercenter')).cla_guid && JSON.parse(localStorage.getItem('usercenter')).cla_guid != '') {
						this.classlistids = JSON.parse(localStorage.getItem('usercenter')).cla_guid;
						res.data.data.forEach(item => {
							if (this.classlistids == item.cla_guid) {
								this.classlistnems = item.cla_name;
							}
						});
					} else {
						if (res.data.data.length > 0) {
							this.classlistids = res.data.data[0].cla_guid;
							this.classlistnems = res.data.data[0].cla_name;
						}
					}

					this.gfarzPageLogList();
				}
			});
		},
		pagesizechanes() {
			this.gfarzPageLogList();
		},
		// 时间筛选
		stchangedate() {
			// console.log(this.vdate)
			let stdate = this.changegodate(this.vdate ?? '');
			this.sdate = stdate;
			this.gfarzPageLogList();
		},
		stchangedates() {
			let edatees = this.changegodate(this.edates);
			this.edate = edatees;
			this.gfarzPageLogList();
		},

		// 快速装换
		changegodate(date) {
			console.log(date);
			let yy = new Date(date).getFullYear();
			let mm = new Date(date).getMonth() + 1;
			let dd = new Date(date).getDate();
			return yy + '/' + mm + '/' + dd;
		},

		tabledeletes(eve, itm) {
			DeleteLog(itm.log_guid).then(res => {
				console.log(res, '删除');
				if (res.data.code == 1) {
					this.$message({
						message: '恭喜你，' + res.data.msg,
						type: 'success'
					});
					this.gfarzPageLogList();
				} else {
					this.$message(res.data.msg);
				}
			});
		},

		searchs() {
			this.pagggenums = 0;
			this.pageindex = 1;
			this.gfarzPageLogList();
		},
		handleCurrentChange(val) {
			this.pageindex = val;
			this.gfarzPageLogList();
		},

		getuserlistas(command) {
			// console.log('command=============>', command);
			this.si_guid = command.si_guid;
			this.school_name = command.si_name_cn;
			this.gfarzPageLogList();
		},
		getusercla(command) {
			console.log('command=============>', command);
			this.classlistids = command.cla_guid;
			this.classlistnems = command.cla_name;
			this.gfarzPageLogList();
		},
		gfarzPageLogList() {
			//console.log('this===========>', this);
			let rzPageobj = {
				si_guid: this.si_guid,
				pageIndex: this.pageindex,
				pageSize: this.pagesize,
				ui_userName: this.ui_userName,
				cla_guid: this.classlistids
			};

			//console.log("rzPageobj============>", rzPageobj);
			GetPageUserlogList(rzPageobj).then(res => {
				// console.log('考勤管理=======>', res);
				this.tableData = res.data.data.list;
				this.pagggenums = res.data.data.totalCount;
			});
		},

		handleClick() {
			alert('button click');
		}
	}
};
</script>
